const scope = 'mouse/';
export const SET_CURRENT_CLICK_POSITION = `${scope}SET_CURRENT_CLICK_POSITION`;
export const CLEAR_MENU = `${scope}CLEAR_MENU`;
export const SET_MENU_DISPLAY = `${scope}SET_MENU_DISPLAY`;
export const SET_MENU_COMPONENT = `${scope}SET_MENU_COMPONENT`;
export const SET_MENU_REFERENCE = `${scope}SET_MENU_REFERENCE`;
